class Hashing {
  static hashHasOneRelation(relation) {
    const where = [
      "upToOne",
      relation.field,
      relation.filter,
      relation.reducedBy
    ];
    return Hashing.hashArray(where);
  }
  static hashHasManyRelation(relation) {
    const where = [
      "possiblyMany",
      relation.field,
      relation.filter,
      "offset" in relation ? relation.offset : void 0,
      "limit" in relation ? relation.limit : void 0,
      "orderBy" in relation ? relation.orderBy : void 0
    ];
    return Hashing.hashArray(where);
  }
  static hashEntityListSubTreeParameters(parameters, environment) {
    if (parameters.isCreating) {
      return Hashing.hashArray([
        parameters.isCreating,
        parameters.entityName,
        environment.getAllVariables()
      ]);
    }
    return Hashing.hashArray([
      parameters.isCreating,
      parameters.entityName,
      parameters.filter,
      parameters.orderBy,
      parameters.offset,
      parameters.limit,
      environment.getAllVariables()
    ]);
  }
  static hashEntitySubTreeParameters(parameters, environment) {
    if (parameters.isCreating) {
      return Hashing.hashArray([
        parameters.isCreating,
        parameters.entityName,
        environment.getAllVariables()
      ]);
    }
    return Hashing.hashArray([
      parameters.isCreating,
      parameters.where,
      parameters.entityName,
      parameters.filter,
      environment.getAllVariables()
    ]);
  }
  static hashArray(array) {
    const json = array.map((item) => JSON.stringify(item)).join("_");
    return Hashing.hash(json);
  }
  static hash(str) {
    let hash = 0;
    if (str.length === 0) {
      return hash;
    }
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash);
  }
}
export {
  Hashing
};
//# sourceMappingURL=Hashing.js.map
